import React, { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import { ReactSVG } from "react-svg";
import Button from "../../../../common/Button";
import { formatToYYYY_MMM_DD, formatTimeFromISO } from "../../../../../helpers/functions";

const VaccineHealthCard = ({
  selectedCard,
  setSelectedCard,
  vaccineResultCard,
  apptBookedVaccines,
  setComingFromEdit,
  setShowVaccineBookingPopup,
  setApptBookedVaccines,
  setVaccineResultCard,
  setVaccineApptBooked,
  setNavigateToVaccinePage,
  saveProgress,
  onDeleteAllVaccines,
  isMA,
  halfBorderSection,
  cardIndex = 2,
}) => {
  return (
    <div
      className={`relative flex flex-row h-[516px] w-[525px] pl-[12px] pt-[14px] rounded-[12px] gap-[10px] border-t-[6px] border-l-[6px] pr-[16px] ${
        selectedCard === cardIndex
          ? "border-REELTeal"
          : "border-blue-200"
      }`}
    >
      {halfBorderSection(cardIndex)}
      <div
        className="flex flex-col justify-center h-[480px] w-[480px] rounded-[12px] bg-teal-25 border-b-gray-100 border-x-gray-100 border-[1px] shadow-lg shadow-gray-400 z-[1]"
        onClick={() => {
          setSelectedCard(cardIndex);
        }}
      >
        {/* Before selecting vaccines*/}
        {!vaccineResultCard && (
          <div
            className="flex flex-col h-[320px] pt-5 pb-2 gap-5 px-12 justify-center"
          >
            <div className="flex flex-col gap-2">
              <h2 className="text-xl font-bold flex justify-center text-teal-300">
                Vaccine Health (Optional)
              </h2>
              <p className="flex justify-center text-gray-800 font-semibold text-base">
                Are you up to date with your Vaccines?
              </p>
            </div>
            <div className="flex flex-col text-gray-800 gap-2">
              {apptBookedVaccines.length === 0 && (
                <Button
                  className="col-span-12 cursor-not-allowed min-h-[70px] !opacity-100 !text-gray-400 !bg-white !border-gray-200"
                  text="No Vaccine Appointment Scheduled"
                  type="primary-outline"
                  disabled
                  onClick={() => {}}
                />
              )}
              {apptBookedVaccines.length > 0 && (
                <Button
                  className="col-span-12 min-h-[70px] flex items-center"
                  text="Book Vaccine Service"
                  type="primary-outline"
                  onClick={() => {
                    setComingFromEdit(true);
                    setShowVaccineBookingPopup(true);
                  }}
                />
              )}
              <Button
                className="col-span-12 min-h-[70px] flex items-center"
                text="Review Vaccine Health"
                type="primary"
                onClick={() => {
                  setNavigateToVaccinePage(true);
                }}
              />
            </div>
          </div>
        )}
        {/* After selecting vaccines*/}
        {vaccineResultCard && (
          <>
            <div className="absolute top-[30px] right-[50px] cursor-pointer z-10" onClick={(e) => e.stopPropagation()}>
              <Menu
                as="div"
                className="relative inline-block text-left"
              >
                {({ open }) => (
                  <>
                    <div>
                      <Menu.Button onClick={(e) => e.stopPropagation()}>
                        <ReactSVG
                          src="/icons/big-triple-dot.svg"
                          className={`flex text-black py-2 px-4 rounded-md ${
                            open ? "bg-gray-100" : ""
                          }`}
                        />
                      </Menu.Button>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform translate-y-2 opacity-0 scale-95"
                      enterTo="transform translate-y-0 opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform translate-y-0 opacity-100 scale-100"
                      leaveTo="transform translate-y-2 opacity-0 scale-95"
                    >
                      <Menu.Items
                        className="absolute right-0 mr-2 w-24 origin-top-right bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-[1000]"
                      >
                        <Menu.Item>
                          <button
                            className="block w-full text-left px-3 py-1 border-b border-b-neutral-70 hover:bg-gray-300"
                            onClick={(e) => {
                              e.stopPropagation();
                              setVaccineApptBooked(false);
                              setComingFromEdit(true);
                              setShowVaccineBookingPopup(true);
                            }}
                          >
                            Edit
                          </button>
                        </Menu.Item>
                        <Menu.Item>
                          <button
                            className="block w-full text-left px-3 py-1 border-b border-b-neutral-70 hover:bg-gray-300"
                            onClick={(e) => {
                              e.stopPropagation();
                              setNavigateToVaccinePage(true);
                            }}
                          >
                            Add
                          </button>
                        </Menu.Item>
                        <Menu.Item>
                          <button
                            className="block w-full text-left px-3 py-1 border-b border-b-neutral-70 hover:bg-gray-300"
                            onClick={(e) => {
                              e.stopPropagation();
                              if (typeof onDeleteAllVaccines === "function") {
                                onDeleteAllVaccines();
                              } else {
                                setApptBookedVaccines([]);
                                setVaccineResultCard(!vaccineResultCard);
                                saveProgress();
                              }
                            }}
                          >
                            Delete All
                          </button>
                        </Menu.Item>
                      </Menu.Items>
                    </Transition>
                  </>
                )}
              </Menu>
            </div>
            <div className="flex flex-col h-[320px] pt-5 pb-2 gap-5 px-12 justify-center items-center">
              <div className="flex justify-center">
                <ReactSVG
                  src={`/icons/follow-up.svg`}
                  className={`w-[80px] h-[80px]`}
                  beforeInjection={(svg) => {
                    svg.setAttribute('width', '80px');
                    svg.setAttribute('height', '80px');
                  }}
                />
              </div>
              <h2 className="text-xl font-bold flex justify-center text-teal-300">
                Vaccine Health Booked
              </h2>
              <div className="flex flex-col text-gray-800 gap-[4px] justify-center items-center">
              <table className="table-fixed border-collapse">
                  <tbody>
                    {apptBookedVaccines?.map((vac, index) => (
                      <tr key={index}>
                        <td className="text-base font-medium text-left w-52 align-top break-words">
                          {vac.name}
                        </td>
                        <td className="text-base font-medium text-left pl-2 align-top whitespace-nowrap">
                          <span>
                            {formatToYYYY_MMM_DD(vac.bookingDate)}{" "}
                            <span className="text-sm text-gray-600">
                              {formatTimeFromISO(vac.bookingDate)}
                            </span>
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default VaccineHealthCard;